import { all } from "redux-saga/effects";
import userSaga from "./user/userSaga";
import productSaga from "./product/productSaga";
import quoteSaga from "./quote/quoteSaga";
import purchaseOrderSaga from "./purchase_order/purchaseOrderSaga";

export default function* rootSaga() {
  yield all([userSaga(), productSaga(), quoteSaga(), purchaseOrderSaga()]);
}
